import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { logout } from "../../../features/auth";
import type { IRoadBedLayerSegments } from "../../../models/storeModels/IRoadBedLayerSegments";

function getInitialState() {
    const initialState: IRoadBedLayerSegments = {
        chosenRoadBedTypeIds: getItemWebStorage('roadBedMapFilters') ?? [],
        pavementGroups: null,
        roadBedLayersFilterIsOpened: false
    }
    return initialState
}

export const roadBedLayerSegmentsSlice = createSlice({
    name: 'roadBedLayerSegments',
    initialState: getInitialState(),
    reducers: {
        setRoadBedTypeIds(state, action: PayloadAction<any>) {
            state.chosenRoadBedTypeIds = action.payload
        },
        setPavementGroups(state, action: PayloadAction<any>) {
            state.pavementGroups = action.payload
        },
        setRoadBedLayerFilterIsOpened(state, action: PayloadAction<any>) {
            state.roadBedLayersFilterIsOpened = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setRoadBedTypeIds, setPavementGroups, setRoadBedLayerFilterIsOpened } = roadBedLayerSegmentsSlice.actions
export const roadBedLayerSegmentsReducer = roadBedLayerSegmentsSlice.reducer;
